import { Skeleton } from '@/shared/components';

export const SavedAddressesSkeleton = () => {
  return (
    <div className="flex flex-col gap-[3rem]">
      {Array.from({ length: 2 }).map((_, index) => (
        <div key={index} className="flex flex-col gap-[1.6rem]">
          <Skeleton
            variant="medium"
            backgroundColor="white"
            className="w-[14.8rem] h-[1.6rem] rounded-[1.2rem]"
          />
          <Skeleton
            variant="medium"
            backgroundColor="white"
            className="w-[100%] h-[9.2rem] rounded-[1.2rem]"
          />
        </div>
      ))}
    </div>
  );
};
